import * as React from 'react';
import strings from 'owa-strings/owa-extensibility-strings';
import { Dialog, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { DialogManifestCacheProvider } from 'owa-addins-osf-facade';
import { observer } from 'mobx-react';
import { OsfHostContainer } from '../components/OsfHostContainer';
import { OutlookEventDispId, unregisterApiEvent } from 'owa-addins-events';
import 'owa-addins-osfruntime/lib/index';
import {
    ActiveDialog,
    ActiveDialogType,
    getAddinCommandForControl,
    getExtensibilityState,
} from 'owa-addins-store';

const styles = require('./IFrameableDialog.scss');

@observer
export default class IFrameableDialog extends React.Component<any, any> {
    private hideDialog(parentControlId: string): void {
        unregisterApiEvent({
            eventDispId: OutlookEventDispId.DISPLAY_DIALOG_DISPID,
            controlId: parentControlId,
        });
    }

    render() {
        const dialog: ActiveDialog = getExtensibilityState().activeDialog;
        if (!dialog) {
            return <div className={styles.divContainer} />;
        }
        if (dialog.isOpen && dialog.dialogType == ActiveDialogType.IFrameable) {
            const addinCommand = getAddinCommandForControl(dialog.parentControlId);
            const appTitle = addinCommand.extension.DisplayName;

            const iframeStyle: any = {
                height: dialog.heightInPercentage + 'vh',
                width: dialog.widthInPercentage + 'vw',
                overflow: 'hidden',
            };

            let closeButtonAriaText = strings.iFrameableDialogCloseButtonAccessibilityLabel;
            if (closeButtonAriaText) {
                closeButtonAriaText = closeButtonAriaText.replace('{0}', appTitle);
            }

            const notifyHostActions = {};
            notifyHostActions[OSF.AgaveHostAction.EscExit] = this.hideDialog;

            return (
                <Dialog
                    hidden={!dialog.isOpen}
                    onDismiss={this.hideDialog.bind(this, dialog.parentControlId)}
                    dialogContentProps={{
                        type: DialogType.close,
                        title: appTitle,
                        closeButtonAriaLabel: closeButtonAriaText,
                    }}
                    modalProps={{
                        isBlocking: true,
                        containerClassName: styles.dialogContainer,
                    }}
                    forceFocusInsideTrap={false}
                    isClickableOutsideFocusTrap={true}>
                    <OsfHostContainer
                        addinCommand={addinCommand}
                        controlId={dialog.controlId}
                        isDialog={true}
                        hostItemIndex={dialog.hostItemIndex}
                        sourceLocation={dialog.url}
                        manifestCacheProvider={DialogManifestCacheProvider}
                        notifyHostActions={notifyHostActions}
                        style={iframeStyle}
                    />
                </Dialog>
            );
        } else {
            return <div className={styles.divContainer} />;
        }
    }
}
